import React from "react";
import styled from "styled-components";

const Wrap = styled.div``;

const Content = () => {
  return (
    <>
      <Wrap>
        <h2>Introduction</h2>

        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/PmiVJeRKons"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>

        <p>
          Brandy Vega, is on a mission to save lives and help others after
          nearly losing her 14-year-old daughter to suicide in 2021. During this
          difficult time she pled for help on social media, and her video went
          viral. Shortly after, KSLTV asked her to share her story on the news.
          In the interview, she told parents to stop what they were doing, go
          check on their kids and ask them point-blank if they are suicidal.
          After the interview aired she received messages from two families that
          followed her advice and checked on their kids saved two kids lives!
          Knowing that two lives out of 20-30 thousand audience were saved, a
          fire in her heart was lit. How many lives could be saved if 20 million
          or even 200 million people could be reached?
        </p>
      </Wrap>
    </>
  );
};

export default Content;
